import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Injector, input, model, signal, viewChild } from '@angular/core';

import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Dialog } from 'primeng/dialog';
import { Button } from 'primeng/button';
import { InputText } from 'primeng/inputtext';
import { SelectMunicipio } from '@/shared/components/layout/select-municipio/select-municipio';
import { MunicipioService } from '@/core/api/sicom-api/registro/medico/municipio/municipio.service';

import { DialogoPadraoDirective } from '@/shared/components/layout/dialogo-padrao/dialogo-padrao.directive';
@Component({
    selector: 'app-municipio-picker',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DialogoPadraoDirective, Dialog, Button, InputText, SelectMunicipio],
    templateUrl: './municipio-picker.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => MunicipioPickerComponent),
            multi: true
        }
    ]
})
/** Seletor de município (ControlValueAccessor) com diálogo de busca. */
export class MunicipioPickerComponent implements ControlValueAccessor {
    disabled = signal(false);
    descricao = signal('');

    dialogVisivel = false;
    tempId: number | null = null;

    selectMunicipioCmp = viewChild<SelectMunicipio>('selectMunicipio');

    onChange: (value: number | null) => void = () => {};
    onTouched: () => void = () => {};

    constructor(private municipioService: MunicipioService) {}

    writeValue(obj: number | string | null): void {
        const id = Number(obj);
        if (Number.isFinite(id) && id > 0) {
            this.tempId = id;
            this.atualizarDescricao(id);
        } else {
            this.tempId = null;
            this.descricao.set('');
        }
    }

    registerOnChange(fn: (value: number | null) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    setDisabledState?(isDisabled: boolean): void {
        this.disabled.set(isDisabled);
    }

    abrirDialog(): void {
        if (this.disabled()) return;
        this.dialogVisivel = true;
    }

    fecharDialog(): void {
        this.dialogVisivel = false;
        this.onTouched();
    }

    onSelecionarMunicipio(id: number | null): void {
        this.dialogVisivel = false;
        this.tempId = id;
        this.onChange(id);
        this.onTouched();

        if (id) {
            // Tenta obter o label diretamente das opções carregadas no componente filho
            const opts = this.selectMunicipioCmp()?.options || [];
            const found = opts.find((o) => o.id === id);

            if (found) {
                this.descricao.set(found.label);
            } else {
                this.atualizarDescricao(id);
            }
        } else {
            this.descricao.set('');
        }
    }

    private atualizarDescricao(id: number): void {
        this.municipioService.buscarMunicipioPorId(id).subscribe({
            next: (municipio) => {
                const municipioUf = municipio as { uf?: string; sgUf?: string; estado?: string } | null;
                const uf: string | undefined = municipioUf?.uf ?? municipioUf?.sgUf ?? municipioUf?.estado ?? undefined;
                const label = municipio ? `${municipio.dsMunicipio} - ${uf ?? ''}`.trim() : '';
                this.descricao.set(label);
            },
            error: () => {
                this.descricao.set('');
            }
        });
    }
}
